import React from 'react'

export const IconBulb: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M11.9944 22.9965C18.0664 22.9965 22.9888 18.0724 22.9888 11.9983C22.9888 5.92409 18.0664 1 11.9944 1C5.92236 1 1 5.92409 1 11.9983C1 18.0724 5.92236 22.9965 11.9944 22.9965Z"
          stroke="#4A4A4A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.79492 8.6989C9.32863 7.18119 10.8788 6.26983 12.4639 6.54182C14.0491 6.81382 15.2071 8.18985 15.2047 9.79873C15.2047 11.9984 11.9063 13.0982 11.9063 13.0982"
          stroke="#4A4A4A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.994 18.5972C12.6012 18.5972 13.0934 18.1048 13.0934 17.4974C13.0934 16.89 12.6012 16.3976 11.994 16.3976C11.3868 16.3976 10.8945 16.89 10.8945 17.4974C10.8945 18.1048 11.3868 18.5972 11.994 18.5972Z"
          stroke="#4A4A4A"
        />
      </g>
    </svg>
  )
}
